<mat-toolbar color="primary" class="sticky-toolbar-router">
  <button (click)="toggleSettingSidenav()" mat-icon-button>
    <mat-icon>keyboard_backspace</mat-icon>
  </button>

  <span>{{translation.settings}}</span>

  <span class="toolbar-fill-remaining-space"></span>
</mat-toolbar>

<mat-card class="mat-card-list">

  <mat-card-header>
    <mat-card-title>{{translation.themes}}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content">
      <div *ngFor="let theme of themeService.themes" class="item" [ngClass]="'theme-'+theme.value"
           (click)="settingService.setTheme(theme.value)">{{ theme.name }}</div>
    </div>

    <br>

    <mat-slide-toggle [ngModel]="settingService.getThemeBackgroundEnabled()" (change)="toggleBackgroundImage()">{{translation.enable_background}}</mat-slide-toggle>
    <br><br>
    <mat-slide-toggle [ngModel]="settingService.getThemeBlurEnabled()" (change)="toggleBackgroundBlur()">{{translation.blur_background}}</mat-slide-toggle>
  </mat-card-content>
</mat-card>

<mat-card class="mat-card-list">

  <mat-card-header>
    <mat-card-title>{{translation.music}}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <mat-slide-toggle [ngModel]="settingService.getIntroEnabled()" (change)="toggleIntro()">{{translation.play_intro}}</mat-slide-toggle>
  </mat-card-content>

</mat-card>

<mat-card class="mat-card-list">

  <mat-card-header>
    <mat-card-title>{{translation.instruments}}</mat-card-title>
    <mat-card-subtitle>{{translation.enableDisableInstruments}}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div class="content" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 8px;">
      <mat-checkbox *ngFor="let key of instrumentKeys"
                    [checked]="isInstrumentEnabled(key)"
                    (change)="onToggleInstrument(key)">
        {{ getInstrumentName(key) }}
      </mat-checkbox>
    </div>
    <div style="margin-top: 8px; font-size: 0.85rem; opacity: 0.75;">
      <!-- Helper: ensure at least one enabled; enforced programmatically -->
    </div>
  </mat-card-content>

</mat-card>

<mat-card class="mat-card-list">

  <mat-card-header>
    <mat-card-title>{{translation.screen_timeout}}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <label>{{settingService.getKeepAwake()? translation.screen_timeout_description : translation.screen_allowsleep_description}}</label>
    <br><br>
    <mat-slide-toggle [ngModel]="settingService.getKeepAwake()" (change)="onKeepAwakeChange()">{{translation.screen_timeout}}</mat-slide-toggle>
  </mat-card-content>
</mat-card>

<mat-card class="mat-card-list">
  <mat-card-header>
    <mat-card-title>{{translation.saved_hymns}}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <button mat-raised-button color="warn" (click)="clearFavorites()">{{translation.clear_favorites}}</button>
    <br><br>
    <button mat-raised-button color="warn" (click)="clearHymnsToLearn()">{{translation.clear_hymns_to_learn}}</button>
    <br><br>
    <button mat-raised-button color="warn" (click)="clearHistory()">{{translation.clear_history}}</button>
  </mat-card-content>
</mat-card>

<br><br>
<div class="version-footer">
  <span>{{translation.title_full}} {{ appVersion }}</span>
</div>
